import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { ApiService } from '@api/service';
import { switchMap, map, tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { AlertService } from './../../api/alert.service';

import * as ownerAction from '../actions/owner.action';

@Injectable()
export class OwnerEffects {
  @Effect()
  getOwner$ = this.actions$.pipe(
    ofType(ownerAction.GET_OWNER),
    switchMap(() => {
      return this.api.user.getProfile().pipe(
        map(res => new ownerAction.GetOwnerSuccess(res)),
        catchError(err => of(new ownerAction.GetOwnerFail(err)))
      );
    })
  );

  @Effect()
  updateOwner$ = this.actions$.pipe(
    ofType(ownerAction.UPDATE_OWNER),
    map((action: ownerAction.UpdateOwner) => action.payload),
    switchMap(({ profile, msg }) => {
      return this.api.user.updateProfile(profile).pipe(
        map(({ profile }) => new ownerAction.UpdateOwnerSuccess(profile)),
        tap(() => this.alertService.addAlert(this.alertService.createCustomAlertObj(msg, 'success', 5000))),
        catchError(err => of(new ownerAction.UpdateOwnerFail(err)))
      );
    })
  );

  @Effect()
  updateOwnerWeight$ = this.actions$.pipe(
    ofType(ownerAction.UPDATE_OWNER_WEIGHT),
    map((action: ownerAction.UpdateOwnerWeight) => action.payload),
    switchMap(({ profile, msg }) => {
      return this.api.user.updateProfileWeight(profile).pipe(
        map(({ profile }) => new ownerAction.UpdateOwnerWeightSuccess(profile)),
        tap(() => this.alertService.addAlert(this.alertService.createCustomAlertObj(msg, 'success', 5000))),
        catchError(err => of(new ownerAction.UpdateOwnerWeightFail(err)))
      );
    })
  );

  @Effect()
  updateOwnerExercise$ = this.actions$.pipe(
    ofType(ownerAction.UPDATE_OWNER_EXERCISE),
    map((action: ownerAction.UpdateOwnerExercise) => action.payload),
    switchMap(({ profile, msg }) => {
      return this.api.user.updateProfileExerciseLevel(profile).pipe(
        map(({ profile }) => new ownerAction.UpdateOwnerExerciseSuccess(profile)),
        tap(() => this.alertService.addAlert(this.alertService.createCustomAlertObj(msg, 'success', 5000))),
        catchError(err => of(new ownerAction.UpdateOwnerExerciseFail(err)))
      );
    })
  );
  constructor(private actions$: Actions, private api: ApiService, private alertService: AlertService) {}
}
